export const IconBack = <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.834 10.5H4.16732" stroke="#EA6B26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 4.66669L4.16667 10.5L10 16.3334" stroke="#EA6B26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
